import { MEDICAL_DETAILS_TITLE_OVERRIDE, sharedCareScoutQuestions } from './careScoutAppSharedQuestions';
import { sharedCareScoutSections } from './careScoutAppSharedSections';

const questions: Record<string, PolicyFormQuestion> = {
  ...sharedCareScoutQuestions,
  advisedByMedicalProfession: {
    id: 'advised-by-medical-profession',
    questionRef: 'advisedByMedicalProfession',
    title:
      'Do you expect to have any medical tests or procedures performed within the next 6 months?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  advisedByMedicalProfessionDetails: {
    id: 'advised-by-medical-profession-details',
    questionRef: 'advisedByMedicalProfessionDetails',
    title:
      'Expect to have any medical tests or procedures performed within the next 6 months details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'advisedByMedicalProfession',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'advisedByMedicalProfession',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  disabilityBenefits: {
    id: 'disability-benefits',
    questionRef: 'disabilityBenefits',
    title: 'Have you requested or received:',
    type: 'radio',
    required: false,
    options: [
      { id: 'workers-comp', value: "Worker's Compensation" },
      { id: 'other-disability', value: 'Other Disability Income' },
    ],
  },
};

export const careScoutDEFormDefinition: PolicyFormDefinition = {
  sections: [
    sharedCareScoutSections.coverageSelection,
    sharedCareScoutSections.eftPaymentAuth,
    sharedCareScoutSections.applicantProfile,
    sharedCareScoutSections.insurabilityProfile,
    sharedCareScoutSections.medicalQuestions,
    sharedCareScoutSections.socialHistory,
    sharedCareScoutSections.familyHistory,
    sharedCareScoutSections.otherCoverage,
    sharedCareScoutSections.protectionLapse,
    sharedCareScoutSections.producerSignature,
    sharedCareScoutSections.ltcAppOverflowForm,
    sharedCareScoutSections.healthInsuranceAuthorization,
    sharedCareScoutSections.ltcInsurancePersonalWorksheet,
    sharedCareScoutSections.verificationFinancialNonDisclosure,
    sharedCareScoutSections.ltcPotentialRateIncreaseDisclosure,
    sharedCareScoutSections.licensedInsuranceProducerInformation,
  ],
  questions,
};
